import React from "react";
import { object, array, bool, number, string } from "prop-types";
import { Link } from "@quintype/components";

import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card3.m.css";

const StoryCard3 = ({
  index,
  story,
  aspectRatio,
  imageType,
  headerType,
  showAuthorName,
  id,
  showRedDot,
  headerLevel
}) => {
  return (
    <div className="story-card story-card-3" styleName="story-card-3" id={`story-card-3-${index}`}>
      <Link href={`/${story.slug}`}>
        <div styleName="row1">
          <Headline
            text={story.headline}
            headerType={headerType}
            headerLevel={headerLevel}
            story={story}
            width={20}
            height={20}
            id={id}
            lineClamp={3}
            showRedDot={showRedDot}
          />

          <CardImage
            story={story}
            aspectRatio={aspectRatio}
            imageType={imageType}
            showAuthorName={showAuthorName}
            showStoryTypeIcon
            showVideoIcon
          />
        </div>
      </Link>

      <Link href={`/${story.slug}`} styleName="summary-link">
        <span styleName="summary" className="summary line-clamp-2">
          {story?.subheadline
            ? story?.subheadline
            : story.seo && story.seo["meta-description"]
            ? story.seo["meta-description"]
            : null}
        </span>
      </Link>
      <StoryDate story={story} />
    </div>
  );
};

StoryCard3.defaultProps = {
  index: 1,
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 2,
  headerLevel: 2,
  showAuthorName: false,
  showSummary: true,
  isExternalStory: false,
  showRedDot: false
};

StoryCard3.propTypes = {
  index: number,
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showAuthorName: bool,
  showSummary: bool,
  id: string,
  isExternalStory: bool,
  pageType: string,
  showRedDot: bool
};

export default StoryCard3;
